var _path, _g, _g2, _g3, _g4, _g5, _rect, _rect2, _g6, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBotEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 115,
    viewBox: "0 0 130 115",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71 85C93.0907 85 111 67.126 111 45C111 22.874 93.0118 5 71 5C48.9093 5 31 22.874 31 45C31 67.126 48.9093 85 71 85Z",
    fill: "#E4E9F4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_47971_104089)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96 30C98.2091 30 100 28.2091 100 26C100 23.7909 98.2091 22 96 22C93.7909 22 92 23.7909 92 26C92 28.2091 93.7909 30 96 30Z",
    fill: "url(#paint0_linear_47971_104089)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_47971_104089)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.441 15.8814C106.789 15.8814 107.881 14.7886 107.881 13.4407C107.881 12.0927 106.789 11 105.441 11C104.093 11 103 12.0927 103 13.4407C103 14.7886 104.093 15.8814 105.441 15.8814Z",
    fill: "#E7EBF7"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_47971_104089)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.142 35.4287C56.5678 35.4287 50.4277 41.5688 50.4277 49.143V50.2858H49.2857C48.0233 50.2858 47 51.3092 47 52.5716V57.143C47 58.4053 48.0233 59.4287 49.2857 59.4287H50.4277V65.143C50.4277 67.6677 52.4744 69.7144 54.9992 69.7144H86.9992C89.5239 69.7144 91.5706 67.6677 91.5706 65.143V49.143C91.5706 41.5688 85.4305 35.4287 77.8563 35.4287H64.142ZM95 52.5716C95 51.3092 93.9767 50.2858 92.7143 50.2858H91.5714V59.4287H92.7143C93.9767 59.4287 95 58.4053 95 57.143V52.5716ZM60.7143 48C57.5584 48 55 50.5584 55 53.7143C55 56.8702 57.5584 59.4286 60.7143 59.4286H81.2857C84.4416 59.4286 87 56.8702 87 53.7143C87 50.5584 84.4416 48 81.2857 48H60.7143Z",
    fill: "url(#paint1_linear_47971_104089)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_47971_104089)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.9986 56.0001C64.261 56.0001 65.2843 54.9768 65.2843 53.7144C65.2843 52.4521 64.261 51.4287 62.9986 51.4287C61.7362 51.4287 60.7129 52.4521 60.7129 53.7144C60.7129 54.9768 61.7362 56.0001 62.9986 56.0001ZM78.9986 56.0001C80.261 56.0001 81.2843 54.9768 81.2843 53.7144C81.2843 52.4521 80.261 51.4287 78.9986 51.4287C77.7362 51.4287 76.7129 52.4521 76.7129 53.7144C76.7129 54.9768 77.7362 56.0001 78.9986 56.0001Z",
    fill: "url(#paint2_linear_47971_104089)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_47971_104089)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.4 23C81.4 24.8778 79.8778 26.4 78 26.4C76.1222 26.4 74.6 24.8778 74.6 23C74.6 21.1222 76.1222 19.6 78 19.6C79.8778 19.6 81.4 21.1222 81.4 23ZM79 27.9C81.2822 27.4367 83 25.419 83 23C83 20.2386 80.7614 18 78 18C75.2386 18 73 20.2386 73 23C73 25.419 74.7178 27.4367 77 27.9V36H79V27.9ZM67.4 27C67.4 28.8778 65.8778 30.4 64 30.4C62.1222 30.4 60.6 28.8778 60.6 27C60.6 25.1222 62.1222 23.6 64 23.6C65.8778 23.6 67.4 25.1222 67.4 27ZM65 31.9C67.2822 31.4367 69 29.419 69 27C69 24.2386 66.7614 22 64 22C61.2386 22 59 24.2386 59 27C59 29.419 60.7178 31.4367 63 31.9V36H65V31.9Z",
    fill: "url(#paint3_linear_47971_104089)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 26.5,
    width: 4,
    height: 1.5,
    fill: "#989FB0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 22.5,
    width: 4,
    height: 1.5,
    fill: "#989FB0"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_47971_104089)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28 82C31.3137 82 34 79.3137 34 76C34 72.6863 31.3137 70 28 70C24.6863 70 22 72.6863 22 76C22 79.3137 24.6863 82 28 82Z",
    fill: "#E6EBF6"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4407 32.8814C26.7886 32.8814 27.8814 31.7886 27.8814 30.4407C27.8814 29.0927 26.7886 28 25.4407 28C24.0927 28 23 29.0927 23 30.4407C23 31.7886 24.0927 32.8814 25.4407 32.8814Z",
    fill: "#EAEEF9"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_47971_104089",
    x: 70,
    y: 11,
    width: 52,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.468625 0 0 0 0 0.575 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_47971_104089"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_47971_104089",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_47971_104089",
    x: 81,
    y: 0,
    width: 48.8813,
    height: 48.8813,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.468625 0 0 0 0 0.575 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_47971_104089"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_47971_104089",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_47971_104089",
    x: 25,
    y: 24.4287,
    width: 92,
    height: 78.2857,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.468625 0 0 0 0 0.575 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_47971_104089"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_47971_104089",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_47971_104089",
    x: 38.7129,
    y: 40.4287,
    width: 64.5714,
    height: 48.5714,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.468625 0 0 0 0 0.575 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_47971_104089"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_47971_104089",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_47971_104089",
    x: 37,
    y: 7,
    width: 68,
    height: 62,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.468625 0 0 0 0 0.575 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_47971_104089"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_47971_104089",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_47971_104089",
    x: 0,
    y: 59,
    width: 56,
    height: 56,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.468625 0 0 0 0 0.575 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_47971_104089"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_47971_104089",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_47971_104089",
    x1: 95.9974,
    y1: 21.815,
    x2: 95.9974,
    y2: 30.0862,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F4F8FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_47971_104089",
    x1: 70.9844,
    y1: 34.6356,
    x2: 70.9844,
    y2: 70.084,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F4F8FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_47971_104089",
    x1: 70.9919,
    y1: 51.323,
    x2: 70.9919,
    y2: 56.0494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F4F8FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_47971_104089",
    x1: 70.9922,
    y1: 17.5836,
    x2: 70.9922,
    y2: 36.1941,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F4F8FE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBotEmpty);
export default __webpack_public_path__ + "static/media/bot-empty.c027e182f29dddcd9cc5ca6653cd242e.svg";
export { ForwardRef as ReactComponent };